import './style/bolmateBadge.scss';

import classNames from 'classnames';

import React, {ReactNode} from 'react';

import BolmateTooltip from '../tooltip/bolmateTooltip';

export type BolmateBadgeColor = 'blue' | 'green' | 'red' | 'orange' | 'gold' | 'gray';
export type BolmateBadgeSize = 'small' | 'normal' | 'big';

interface Props {
    label: ReactNode;
    color?: BolmateBadgeColor;
    size?: BolmateBadgeSize;
    tooltip?: string;
    className?: string;
}

export default function BolmateBadge(props: Props) {
    const {label, color = 'blue', size = 'normal', tooltip, className} = props;

    const element = (
        <span className={classNames('bolmate-badge', `color-${color}`, `size-${size}`, className)}>{label}</span>
    );

    if (tooltip) {
        return <BolmateTooltip text={tooltip}>{element}</BolmateTooltip>;
    }

    return element;
}
